if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');      
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.bmcBusy(true);

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if(this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } 
            else if(!this.cart){
            this.error = false;
            this.bmcAdded();
            return;
          }

          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          this.bmcBusy(false, !this.error);
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
        });
    }

    /* Brand My Cap: button says "Adding…" with a sliding bar while busy, then "Added ✓" for a moment */
    bmcBusy(on, ok) {
      const btn = this.submitButton;
      const label = btn.querySelector('span');
      if (!label) return;
      if (on) {
        clearTimeout(this._bmcBtnT);
        if (!btn.dataset.bmcLabel) btn.dataset.bmcLabel = label.textContent.trim();
        btn.classList.remove('bmc-added');
        btn.classList.add('bmc-adding');
        label.textContent = 'Adding to cart…';
        return;
      }
      btn.classList.remove('bmc-adding');
      if (ok) {
        btn.classList.add('bmc-added');
        label.textContent = 'Added ✓';
        this._bmcBtnT = setTimeout(() => {
          btn.classList.remove('bmc-added');
          label.textContent = btn.dataset.bmcLabel;
        }, 2000);
      } else if (!label.classList.contains('hidden')) {
        label.textContent = btn.dataset.bmcLabel;
      }
    }

    /* Brand My Cap: stay on the page after adding, show a message and refresh the cart count */
    bmcAdded() {
      fetch(window.location.pathname + '?sections=cart-icon-bubble')
        .then((r) => r.json())
        .then((s) => {
          const bubble = document.getElementById('cart-icon-bubble');
          if (!bubble || !s['cart-icon-bubble']) return;
          const doc = new DOMParser().parseFromString(s['cart-icon-bubble'], 'text/html');
          const inner = doc.querySelector('.shopify-section') || doc.body;
          bubble.innerHTML = inner.innerHTML;
        })
        .catch(() => {});
      let toast = document.getElementById('bmc-added-toast');
      if (!toast) {
        toast = document.createElement('div');
        toast.id = 'bmc-added-toast';
        toast.className = 'bmc-toast';
        toast.setAttribute('role', 'status');
        toast.setAttribute('aria-live', 'polite');
        document.body.appendChild(toast);
      }
      toast.innerHTML = '<span class="bmc-toast__tick" aria-hidden="true">&#10003;</span><span class="bmc-toast__text">Added to your cart</span>' +
        '<a class="bmc-toast__link" href="' + window.routes.cart_url + '">View cart</a>' +
        '<button type="button" class="bmc-toast__close" aria-label="Close">&times;</button>';
      toast.querySelector('.bmc-toast__close').addEventListener('click', () => toast.classList.remove('is-open'));
      requestAnimationFrame(() => toast.classList.add('is-open'));
      clearTimeout(this._bmcToastT);
      this._bmcToastT = setTimeout(() => toast.classList.remove('is-open'), 6000);
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
